import { useEffect, useState } from "react";
import { IdCard, Phone } from "lucide-react";
import { toast } from "sonner";
import { trpc } from "@/lib/trpc";
import { FieldWithIcon } from "@/components/profile/FieldWithIcon";
import { MyEmailsSection } from "@/components/profile/MyEmailsSection";
import { TabSaveBar } from "@/components/profile/TabSaveBar";
import { useRecarregarPerfil } from "./use-recarregar-perfil";

function formatCpf(v: string): string {
  const d = v.replace(/\D/g, "").slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
}

function formatPhone(v: string): string {
  const d = v.replace(/\D/g, "").slice(0, 11);
  if (d.length <= 2) return d ? `(${d}` : "";
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

/** Telefone, CPF e e-mails da pessoa. */
export function ContatoSecao() {
  const user = trpc.me.current.useQuery().data;
  const recarregar = useRecarregarPerfil();
  const [phone, setPhone] = useState("");
  const [cpf, setCpf] = useState("");

  useEffect(() => {
    setPhone(user?.phone ?? "");
    setCpf(user?.cpf ?? "");
  }, [user?.phone, user?.cpf]);

  const update = trpc.me.updateProfile.useMutation({
    onSuccess: () => {
      toast.success("Contato atualizado.");
      recarregar();
    },
    onError: (err) => toast.error(err.message || "Não foi possível salvar."),
  });
  if (!user) return null;

  const dirty = phone !== (user.phone ?? "") || cpf !== (user.cpf ?? "");

  return (
    <div className="space-y-6 px-6 py-5">
      <div className="space-y-6">
        <div className="grid gap-4 sm:grid-cols-2">
          <FieldWithIcon
            icon={Phone}
            label="Telefone"
            htmlId="ct-phone"
            value={formatPhone(phone)}
            onChange={(e) => setPhone(e.target.value.replace(/\D/g, "").slice(0, 11))}
            placeholder="(11) 98765-4321"
          />
          <FieldWithIcon
            icon={IdCard}
            label="CPF"
            htmlId="ct-cpf"
            value={formatCpf(cpf)}
            onChange={(e) => setCpf(e.target.value.replace(/\D/g, "").slice(0, 11))}
            placeholder="000.000.000-00"
          />
        </div>
        <TabSaveBar dirty={dirty} isPending={update.isPending} onSave={() => update.mutate({ phone: phone || undefined, cpf: cpf || undefined })} />
      </div>
      <MyEmailsSection />
    </div>
  );
}
